import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SocialMediaPopover } from './socialMediaPopover.js';
import { UserAvatarV2 } from './commonControls.jsx.js';
import { LinkPreview } from './linkPreview.jsx.js';
import { HoverModal } from './hoverModal';
import ReactLinkify from 'react-linkify';
import { Link } from 'react-router-dom';
import AddCardModal from './addCardModal';
import {Parser} from 'html-to-react';
const htmlParser = new Parser();
import {
    Card, CardHeader, CardContent, CardActions,
    Typography, Button, Chip
} from '@material-ui/core';

import * as localStorage from '../localStorage';
import utils from '../utils';
import moment from 'moment';
import { DiscussionMentionInput } from './discussionMentionInput.js';
import { forEach } from 'jszip';

const DATE_FMT = 'lll';

const NEW_INDICATOR_TIMEOUT = 60 * 60 * 24; //24 hours

export function DiscussionTopicCard(props) {
    const { comment, eventHandlers, isOwner, isSponsor, isExpandable } = props;
    const { childComments: replies } = comment;
    const latest = replies[replies.length - 1];
    const [isExpanded, setIsExpanded] = useState(
        props.isExpanded || localStorage.getItem(`expand-${comment.idCardComment}`) == 'true'
    );

    return (
        <div className='comment-topic-card'>
            <Card
                id={`comment-${comment.idCardComment}`}
                className={`comment-card ${comment.isPinned ? 'pinned' : '' 
                    || isSponsor(comment.user.idUser) ? 'sponsored' : ''}`
                }
            >
                <CardContent style={{ paddingBottom: 16 }}>
                    <div className='column-items'>
                        <div className='comment-title'>
                            <div className='title-top'>
                                <Link to={`/discussion?idThread=${comment.idCardComment}&idIncubator=${comment.idPortfolio}`} target='_parent'>
                                    {comment.title || comment.text.substring(0, 150)}
                                </Link>
                                <NewIndicator comment={comment} />
                            </div>
                            <div className='title-bottom'>
                                <DiscussionCardActions
                                    comment={comment}
                                    isOwner={isOwner}
                                    eventHandlers={{ ...eventHandlers, onEdit: undefined, onDisable: undefined }}
                                />
                                <span>
                                    {moment(comment.creationTime).format(DATE_FMT)}
                                </span>
                                <span>
                                    <HoverModal
                                        linkTo={`/users/profile?idUser=${comment.user.id}`}
                                        textTitle={<span><b>{`${comment.user.firstName} ${comment.user.lastName} ${(isSponsor && isSponsor(comment.user.idUser) ? '(Host)' : '')}`}</b></span>}
                                        titleStyle={{ fontSize: 14, color: '#4457CF' }}
                                        avatar={comment.user.hasAvatar ? `${window.globals.USER_UPLOADS_BASE_URL}/${comment.user.id}/Avatar.png` : null}
                                        chipText={`Level ${utils.calculateUserLevel(comment.user.points)} (${comment.user.points})`}
                                        hoverTitle={`${comment.user.firstName} ${comment.user.lastName}`}
                                        hoverSubtitle={`${comment.user.affiliation || ''}`}
                                        hoverText={comment.user.bio || ''}
                                        hoverAnchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        hoverTransformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                    />
                                </span>
                            </div>
                        </div>
                        <div className='comment-count'>
                            {replies.length + 1}
                        </div>
                        <div className='latest-comment'>
                            {latest ? (
                                <>
                                    <span>{moment(latest.creationTime).format(DATE_FMT)}</span>
                                    <HoverModal
                                        linkTo={`/users/profile?idUser=${latest.user.id}`}
                                        textTitle={<span><b>{`${latest.user.firstName} ${latest.user.lastName} ${(isSponsor && isSponsor(latest.user.idUser) ? '(Host)' : '')}`}</b></span>}
                                        titleStyle={{ fontSize: 14, color: '#4457CF' }}
                                        avatar={latest.user.hasAvatar ? `${window.globals.USER_UPLOADS_BASE_URL}/${latest.user.id}/Avatar.png` : null}
                                        chipText={`Level ${utils.calculateUserLevel(latest.user.points)} (${latest.user.points})`}
                                        hoverTitle={`${latest.user.firstName} ${latest.user.lastName}`}
                                        hoverSubtitle={`${latest.user.affiliation || ''}`}
                                        hoverText={latest.user.bio || ''}
                                        hoverAnchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        hoverTransformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                    />
                                </>
                            ) : (
                                'No Comment'
                            )}
                        </div>
                    </div>
                    {isExpandable &&
                        <Button
                            aria-label='expand-comments'
                            className='portfolio-list-page-tab'
                            color='primary'
                            size='medium'
                            endIcon={<FontAwesomeIcon icon={['far', `chevron-${isExpanded ? 'up' : 'down'}`]} />}
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            Comments: {`${comment.childComments.length + 1}`}
                        </Button>
                    }
                </CardContent>
            </Card>
            {isExpandable && isExpanded &&
                <ChildComments showParent hideComments={() => setIsExpanded(false)} { ...props } topThread = {false}/>
            }
        </div>
    );
}

export function DiscussionCommentCard(props) {
    const { comment, isSponsor, isOwner, isSubmitter, disableIndicator, isExpandable,
        disableCardPreview, allUsers, updateCommentTree, order, topThread} = props;
    let { eventHandlers } = props;
    const { user } = comment;
    const [showEditMode, setShowEditMode] = useState(false);
    let initialIsExpanded = props.isExpanded
       || localStorage.getItem(`expand-${comment.idCardComment}`) === 'true'
       || comment.shouldExpand
    const [isExpanded, setIsExpanded] = useState(initialIsExpanded);

    useEffect(() => {
        if(comment.shouldExpand)
            setIsExpanded(true);
        comment.shouldExpand = false;
    })

    eventHandlers.onEditPressed = () => {
        setShowEditMode(!showEditMode);
    }

    eventHandlers.onSubmitPressed = (comment, text) => {
        setShowEditMode(false);
        eventHandlers.onEdit(comment, text);
    }

    let formattedComment = comment.text
        .split('@@@__').join("<a target=\"_blank\" href=\"/users/profile?idUser=")
        .split('^^__').join("\">")
        .split('@@@^^^').join("</a>");

    const newWindowDecorator = (href, text, key) => (
        <a href={href} key={key} target="_blank">
            {text}
        </a>
    );
    let orderNumber = order;
    let nameFlair = '';
    let submitter = isSubmitter ? isSubmitter(user.idUser) : false;
    let sponsor = isSponsor ? isSponsor(user.idUser) : false;
    if (sponsor && submitter) {
        nameFlair = '(Host/Submitter)';
    } else if (sponsor) {
        nameFlair = '(Host)';
    } else if (submitter) {
        nameFlair = '(Submitter)';
    }

    if(comment.hide && props.allowHide){
        return null;
    }

    return (
        <div className='comment-regular-card'>
            <Card
                id={`comment-${comment.idCardComment}`}
                className={`comment-card ${comment.isPinned ? 'pinned' : '' 
                    || isSponsor(comment.user.idUser) ? 'sponsored' : ''}`}
            >
                <CardHeader
                    className='mPub-header'
                    avatar={<UserAvatarV2 size='small' userData={user} />}
                    title={
                        <div>
                        <span className='user-date'>
                            <HoverModal
                                linkTo={`/users/profile?idUser=${comment.user.id}`}
                                textTitle={`${comment.user.firstName} ${comment.user.lastName} ${nameFlair}`}
                                titleStyle={{ fontSize: 15, color: '#4457CF', fontWeight:600 }}
                                avatar={comment.user.hasAvatar ? `${window.globals.USER_UPLOADS_BASE_URL}/${comment.user.id}/Avatar.png` : null}
                                chipText={`Level ${utils.calculateUserLevel(comment.user.points)} (${comment.user.points})`}
                                hoverTitle={`${comment.user.firstName} ${comment.user.lastName}`}
                                hoverSubtitle={`${comment.user.affiliation || ''}`}
                                hoverText={comment.user.bio || ''}
                                hoverAnchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                hoverTransformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            />
                            <div className='creation-date'>
                                • {moment(comment.creationTime).format('lll') + ' EST'}
                            </div>
                            <NewIndicator forceDisable={disableIndicator} comment={comment} onDismiss={() => updateCommentTree()} />
                        </span>
                        <div
                           className={'discussion-order-number'}
                           style={{display:'flex', float:'right'}}
                        >
                            {orderNumber}
                        </div>
                        </div>
                    }

                />
                <hr />
                <CardContent className='comment-content'>
                    {!showEditMode ? (
                        <>
                            <LinkPreview title={comment.linkTitle} description={comment.linkDescription} image={comment.linkImage} idCard={disableCardPreview ? null : comment.idCard} cardType={comment.cardType} />
                            <ReactLinkify componentDecorator={newWindowDecorator}>
                                {htmlParser.parse(formattedComment)}
                            </ReactLinkify>
                        </>
                    ) : (
                        <CommentSubmissionBox
                            comment={comment}
                            initialText={comment.text}
                            allUsers={allUsers}
                            typingFunction={(bIsTyping) => props.typingFunction(bIsTyping, comment)}
                            onSubmit={eventHandlers.onSubmitPressed}
                        />
                    )}
                </CardContent>
                <CardActions>
                    {isExpandable &&
                        <Button
                            aria-label='expand-comments'
                            className={`portfolio-list-page-tab ${comment.childComments.length > 0 ? `expand-comments-button` : 'comments-reply-button'}`}
                            color='primary'
                            size='small'
                            startIcon={<FontAwesomeIcon icon={comment.childComments.length > 0
                                ? ['far', `chevron-${isExpanded ? 'up' : 'down'}`]
                                : ['fas', 'comment-alt']}
                            />}
                            onClick={e => {
                                e.stopPropagation();
                                localStorage.setItem(`expand-${comment.idCardComment}`, !isExpanded);
                                setIsExpanded(!isExpanded);
                            }}
                        >
                            {comment.childComments.length > 0 ? `Replies (${comment.childComments.length})` : 'Reply'}
                        </Button>
                    }
                    <DiscussionCardActions
                        comment={comment}
                        isOwner={isOwner}
                        eventHandlers={eventHandlers}
                    />
                </CardActions>
            </Card>
            {isExpandable && isExpanded &&
                <ChildComments
                    {...props}
                    topThread = {false}
                    order = {order}
                    hideComments={e => {
                        e.stopPropagation();
                        localStorage.setItem(`expand-${comment.idCardComment}`, false);
                        setIsExpanded(false);
                    }}
                />
            }
        </div>
    );
}

function DiscussionCardActions(props) {
    const { comment, eventHandlers, isOwner } = props;
    const { onLike, onDelete, onPin, onDisable, onEdit, onEditPressed } = eventHandlers;
    const isUser = comment.user.idUser == window.globals.idUser;
    const userLikedComment = comment.likes.find(c => c.idUser == window.globals.idUser) != null;

    return (
        <div className='discussion-actions'>
          {onLike && <Button
                onClick={() => onLike(comment)}
                className='like-btn material-button'
                size='small'
                startIcon={
                    <FontAwesomeIcon icon={[`${userLikedComment ? 'fas' : 'far'}`, 'thumbs-up']} />
                }
            >
                {comment.likes.length}
            </Button>}
            <SocialMediaPopover
                url={utils.createUrlForPortfolioComment(comment.idCardComment)}
                body='Check out this interesting thread on Polyplexus!'
                subject='Polyplexus Discussion'
                button={
                    <Button
                        aria-label='Share'
                        className='portfolio-list-page-tab'
                        color='primary'
                        size='small'
                        startIcon={<FontAwesomeIcon icon={['far', 'share']} />}
                    >
                        Share
                    </Button>
                }
            />
            {isUser && moment(comment.creationTime).add(10, 'minutes') > moment() && onEdit &&
                <Button
                    onClick={onEditPressed}
                    className='material-button'
                    size='small'
                    startIcon={<FontAwesomeIcon icon={['far', 'edit']} />}
                >
                    Edit
                </Button>
            }
            {(isOwner(window.globals.idUser)) && onDelete &&
                <Button
                    onClick={() => onDelete(comment)}
                    className='material-button'
                    size='small'
                    startIcon={<FontAwesomeIcon icon={['far', 'trash']} />}
                >
                    Delete
                </Button>
            }
            {isOwner(window.globals.idUser) &&
                <>
                    {onDisable &&
                        <Button
                            onClick={() => onDisable(comment)}
                            className='material-button'
                            size='small'
                            aria-label='disable'
                            color='primary'
                            startIcon={
                                <FontAwesomeIcon icon={['far', comment.isDisabled ? 'comment' : 'comment-slash']} />
                            }
                        >
                            {comment.isDisabled ? 'Enable' : 'Disable'}
                        </Button>
                    }
                    {onPin &&
                        <Button
                            onClick={() => onPin(comment)}
                            className='portfolio-list-page-tab'
                            size='small'
                            aria-label='Pin'
                            color='primary'
                            startIcon={
                                <FontAwesomeIcon icon={[comment.isPinned ? 'fas' : 'far', 'thumbtack']} />
                            }
                        >
                            {comment.isPinned ? 'Unpin' : 'Pin'}
                        </Button>
                    }
                </>
            }
        </div>
    );
}

function ChildComments(props) {
    const { showParent, comment, allUsers, eventHandlers, hideComments , order} = props;
    const { childComments: replies = [] } = comment;
    const numberedComments = replies
    const pinnedComments = numberedComments
        .filter(c => c.isPinned)
        .map(c => (
            <DiscussionCommentCard
                key={c.idCardComment}
                { ...props }
                order = {c.order}
                comment={c}
            />
        ));
    const restComments = numberedComments
        .filter(c => !c.isPinned)
        .sort((a, b) => new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime())
        .map(c =>(
            <DiscussionCommentCard
                key={c.idCardComment}
                { ...props }
                order = {c.order}
                comment={c}
            />
        ));

    return (
        <div className='expanded-section'>
            <div className='vertical-line'
                onClick={e => hideComments(e)}
            />
            <div className='expanded-comments'>
                {showParent &&
                    <DiscussionCommentCard
                        {  ...props }
                        order = {comment.order}
                    />
                }
                {pinnedComments}
                {restComments}
                <CommentSubmissionBox
                    comment={comment}
                    allUsers={allUsers}
                    typingFunction={(bIsTyping) => props.typingFunction(bIsTyping, comment)}
                    onSubmit={eventHandlers.onSubmit}
                />
            </div>
        </div>
    );
}

export function CommentSubmissionBox(props) {
    const { comment = {}, onSubmit, typingFunction, allUsers, initialText = '' } = props;
    const [modalOpen, setModalOpen] = useState(false);
    const [enableSubmit, setEnableSubmit] = useState(true);
    const [newComment, setNewComment] = useState(initialText);
    const [timer, setTimer] = useState(5000);
    const [typing, setTyping] = useState(false);

    let handleKeyPress = () => {
        if (typingFunction) {
            window.clearTimeout(timer);
            if (typing) {
               window.clearTimeout(timer);
            } else {
                typingFunction(true);
                setTyping(true);
            }
        }
    }

    let handleKeyUp = () => {
        if (typingFunction) {
            window.clearTimeout(timer);
            setTimer(window.setTimeout(() => {
                typingFunction(false);
                setTyping(false);
            }, 5000));
        }
    }

    return (
        <div className='comment-submission'>
            {comment.isDisabled ? (
                <Typography variant='h6'>
                    Commenting has been disabled.
                </Typography>
            ) : (
                <div>
                    <DiscussionMentionInput
                        placeholder='New Comment'
                        onKeyPress={handleKeyPress}
                        onKeyUp={handleKeyUp}
                        value={newComment}
                        users={allUsers}
                        onChange={e => setNewComment(e.target.value)}
                    />
                    <Button
                        className='comment-submit'
                        onClick={() => {
                            setEnableSubmit(false);
                            onSubmit(comment, newComment);
                            setNewComment('');
                            setEnableSubmit(true);
                        }}
                        size='small'
                        color='primary'
                        variant='outlined'
                        disabled={
                            comment.isDisabled
                            || newComment.trim() === ''
                            || !enableSubmit
                        }
                    >
                        Submit
                    </Button>
                    <Button
                        className='comment-add-evidence'
                        onClick={() => setModalOpen(true)}
                        size='small'
                        color='secondary'
                        variant='outlined'
                        className='material-button'
                        style={{textTransform: 'none'}}
                    >
                        LINK µPUB
                    </Button>
                    <AddCardModal
                        open={modalOpen}
                        handleClose={() => setModalOpen(false)}
                        addCardFunction={(id, type) => {
                            setNewComment(`${newComment}\n${utils.createUrlForCard(id, type)}`);
                            setModalOpen(false);
                        }}
                    />
                </div>
            )}
        </div>
    );
}

function NewIndicator(props) {
    const { comment, forceDisable } = props;
    const [showNewIndicator, setShowNewIndicator] = useState(true);
    let newestCommentInTree = getNewestCommentInTree(comment);

    if(!newestCommentInTree){
        return null;
    }

    let timeElapsedS = calculateElapsed(newestCommentInTree.creationTime);

    let newCommentExists = timeElapsedS < NEW_INDICATOR_TIMEOUT;
    let lastDismissedTime = new Date(localStorage.getItem(`hide-${comment.idCardComment}`));
    let isLatestCommentAfterLastDismissal = new Date(lastDismissedTime) < new Date(new Date() - timeElapsedS * 1000);
    if( !newCommentExists
       || !isLatestCommentAfterLastDismissal
       || forceDisable
       || !showNewIndicator
    )
    {
        return null;
    }


    return (
        <Chip
            size='small'
            className='fade-out'
            color='default'
            label='New'
            deleteIcon={<FontAwesomeIcon icon={['far', 'times']} />}
            onDelete={() => {
                localStorage.setItem(`hide-${comment.idCardComment}`, new Date().toISOString());
                setShowNewIndicator(false);
                if(props.onDismiss)
                    props.onDismiss();
            }}
            style={{
                float:'right',
                fontWeight: 600,
                marginRight:'2em',
                backgroundColor:'#FFC30F',
                color:'black',
                animationName:'darken-animation',
                animationDuration: '600s',
                animationDelay: '-' + timeElapsedS + 's',
                animationFillMode: 'forwards',
            }}
        />
    );
}

function calculateElapsed(time) {
    return Math.abs(Math.round((new Date(time) - new Date()) / 1000));
}

function getNewestCommentInTree(rootComment){
    if(rootComment.childComments.length === 0){
        if(rootComment.user.id !== parseInt(window.globals.idUser) && !localStorage.getItem(`hide-${rootComment.idCardComment}`))
            return rootComment;
        else{
            return null;
        }
    }

    let newestComment = null;
    let newestCommentElapsedTime = NEW_INDICATOR_TIMEOUT;
    for(let comment of rootComment.childComments){
        let newestSubComment = getNewestCommentInTree(comment);
        if(!newestSubComment){
            continue;
        }
        let newestSubCommentElapsedTime = calculateElapsed(newestSubComment.creationTime);
        if(newestSubCommentElapsedTime < newestCommentElapsedTime && newestSubComment.user.id !== parseInt(window.globals.idUser)){
            newestCommentElapsedTime = newestSubCommentElapsedTime;
            newestComment = newestSubComment;
        }
    }
    return newestComment;
}
